<template>
  <div class="bd">
    <!-- 监控页面 -->
    <div class="main" :type="type">
      <div class="right right-overflow" :style="'height:'+screenHeight"> 
        <div class="slip_in_animation">
          <div class="right-content slip_in_animation">
            <div class="type-title">
              <div>拆解区-洗衣机塑料分选区</div>
            </div>
            <div class="item-info">
              <video
                style="width: 100%; height: auto"
                controls
                src="https://player.alicdn.com/video/editor.mp4"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "modelWatchInfoRight",
  props: ["type","screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
    };
  },
  mounted() {
    console.log(this.type);
  },
  methods: {},
};
</script>
  <style scoped lang="scss">
::-webkit-scrollbar {
  width: 0px;
}

.main .left,
.main .right {
  width: 21.3vw;
  height: 75vh;
  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
  .left-content {
    box-sizing: border-box;
    padding: 20px;
    color: #fff;
  }
  .left-content .company-content {
    line-height: 40px;
    font-size: 18px;
    height: 51vh;
    overflow-y: scroll;
    scroll-behavior: smooth;
    overscroll-behavior: contain;
  }
  .left-item-info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 20px 0;
    .all-number {
      font-size: 22px;
      text-align: center;
      .text {
        margin-top: 20px;
        font-size: 28px;
      }
    }
  }
}
.main .right {
  float: right;
  margin-right: 20px;
  .right-content {
    box-sizing: border-box;
    padding: 20px;
    color: #fff;
    .item-info {
      > div {
        margin: 20px 0;
        font-size: 20px;
      }
    }
  }
}
.right-overflow {
  overflow-y: scroll !important;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
.list-box {
  background: #4e83ca;
  padding: 10px 0;
  .table-head,
  .main-item {
    /* padding: 5px 20px; */
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  .table-head {
    padding-bottom: 10px;
    border-bottom: 1px rgb(193, 193, 193) solid;
  }
  .table-head > div,
  .main-item > div {
    width: 25%;
    text-align: center;
  }

  .main-item > div {
    border-bottom: 1px rgb(193, 193, 193) solid;
  }
  .table-main {
    line-height: 80px;
    font-size: 18px;
    height: 15vh;
    overflow-y: scroll;
    scroll-behavior: smooth;
    overscroll-behavior: contain;
  }
}
.bottom-list-box {
  /* background: #4e83ca; */
  padding-left: 20px;
  line-height: 80px;
  font-size: 18px;
  height: 32vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
::v-deep .main .left .left-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .main .right .right-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
  